module.exports = __webpack_public_path__ + "img/with-love_cn.d8610fd.jpg";